/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { Review } from './Review'
import { ReviewFromJSON, ReviewFromJSONTyped, ReviewToJSON } from './Review'

/**
 *
 * @export
 * @interface PaginatedReviewAdmin
 */
export interface PaginatedReviewAdmin {
  /**
   *
   * @type {Array<Review>}
   * @memberof PaginatedReviewAdmin
   */
  results: Array<Review>
  /**
   *
   * @type {number}
   * @memberof PaginatedReviewAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedReviewAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedReviewAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedReviewAdmin interface.
 */
export function instanceOfPaginatedReviewAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedReviewAdminFromJSON(json: any): PaginatedReviewAdmin {
  return PaginatedReviewAdminFromJSONTyped(json, false)
}

export function PaginatedReviewAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedReviewAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(ReviewFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedReviewAdminToJSON(value?: PaginatedReviewAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(ReviewToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
